module.exports = __webpack_public_path__ + "static/dina_before-1de05d05550e69023a9a62ed6c9e093e.png";